import { readCallbackParams } from './callback-params'

/**
 * The callback parameters, captured at MODULE LOAD.
 *
 * This exists solely to win a race. `detectSessionInUrl` makes the Supabase
 * client consume the callback and then rewrite the address bar, which destroys
 * `next` and `type` before any component gets to look at them. So this module
 * reads the URL once, synchronously, and must be evaluated BEFORE
 * ../lib/supabase.ts constructs the client.
 *
 * That ordering is enforced by import order in main.tsx: this module is
 * imported for its side effect ahead of ./App. Do not import it lazily, and do
 * not move the import below ./App.
 */
export const initialCallback = readCallbackParams(new URL(window.location.href))
